/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ReactComponent as IndustryIcon } from '../../../../assets/svg/company-icon/industry.svg';
import ToolTip from '../ToolTip';

const CompanyIndustry = props => {
  const {
    industry = '',
    parentClass = '',
    clsName = '',
    showToolTipOnHover = false,
  } = props;

  return industry !== undefined && industry !== '' && industry !== null ? (
    <div
      className={`company-industry icon-wrap toolTipParentWrap ${parentClass}`}
    >
      <IndustryIcon className="svg-icon" />
      <div
        className={`item-name show-elipsis  ${clsName} ${
          showToolTipOnHover ? ' show-hover-tooltip' : ''
        }`}
        title={showToolTipOnHover ? '' : industry}
      >
        {industry}
      </div>
      {showToolTipOnHover && <ToolTip toolTipText={industry} />}
    </div>
  ) : (
    ''
  );
};

export { CompanyIndustry };
export default CompanyIndustry;
